import React from 'react';

export const getStringWithIcon = ({ text, iconName, iconComponent }) => {
  const splitDescription = text.split(iconName);
  return (
    <>
      {splitDescription[0]}
      {iconComponent}
      {splitDescription[1]}
    </>
  );
};

export const calculateHeightWeeklyPlan = () => {
  const getHeightElement = (id) =>
    document.getElementById(id)?.offsetHeight || 0;
  const mainHeader = getHeightElement('toolbar_container');
  const toolbarSubmodule = getHeightElement('menu_submodules');
  const toolbarWeeklyPLan = getHeightElement('weeklyplan_toolbar');
  const height = mainHeader + toolbarSubmodule + toolbarWeeklyPLan;
  return height;
};

export const getHeightWeeklyPlan = () =>
  `calc(100vh - ${calculateHeightWeeklyPlan()}px)`;
